import { render, staticRenderFns } from "./UAV_system.vue?vue&type=template&id=659bd494"
import script from "./UAV_system.vue?vue&type=script&lang=js"
export * from "./UAV_system.vue?vue&type=script&lang=js"
import style0 from "./UAV_system.vue?vue&type=style&index=0&id=659bd494&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports